import { captureException } from '@sentry/node';

import { doRequest } from '@r1-frontend/do-request/index';
import { addCard } from '@r1-frontend/api-domru/api-pay/v1/card/add';
import { IRegPayCard } from '@r1-frontend/api-domru/api-pay/v1/card/dto/IRegPayCard';

import { TAppThunkDispatch, TGetState } from '~/src/store';

import { IPaymentResult, setPaymentResult } from '../actionCreators';

// подключение автоплатежа с привязкой новой карты (без оплаты и списания бонусов)
const newCardAutoPayConnect = () => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const {
            city: { provider: { providerId } },
            payment: { paymentData: { isConnectAutoPay }, autopayDay, result },
        } = getState();

        const return_url = location.origin + '/payments-response?';
        const params = {
            autopay_act: +isConnectAutoPay,
            autopay_day: autopayDay,
            return_url,
            payment_source: 1,
        };

        const resp = await doRequest.apiPay<IRegPayCard>(
            addCard(providerId, params),
        );

        if (resp.isSuccess) {
            const respData: IPaymentResult = {
                ...result,
                frameUrl: resp.payload.payUrl,
            };
            dispatch(setPaymentResult(respData));
        } else {
            captureException(resp);
        }
    };
};

export default newCardAutoPayConnect;
